import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { Outlet, Navigate, useLocation, Link } from 'react-router-dom';
import { removeCookie } from '@/app/common/utils/cookieService';
import useDomain from '@/hooks/useDomain';
import IconAlert from '@/components/common/IconAlert';
import IconButton from '@/components/common/IconButton';
import AuthPreload from './AuthPreload';

const ProtectedRoute = () => {
  const { pathname } = useLocation();
  const { data: userInfo, isSuccess, isLoading } = useGetUserInfoQuery();

  window.addEventListener('goftino_ready', function () {
    if (userInfo && userInfo?.data?.goftino_id) {
      window.Goftino?.setUserId(userInfo.data.goftino_id);
    }
    switch (localStorage.getItem('goftino_p')) {
      case 'left':
        window.Goftino?.setWidget({
          hasIcon: true,
          marginRight: 200
        });
        break;
      case 'right':
        window.Goftino?.setWidget({
          hasIcon: true,
          marginRight: 100,
          cssUrl: '/widget.css'
        });
        break;
      case 'none':
        window.Goftino?.setWidget({
          hasIcon: false
        });
        break;
      default:
        break;
    }
  });

  const { domain } = useDomain();
  const noDomainIsOkRoutes = [
    'domains',
    'settings',
    'prorogate-or-upgrade',
    'orders'
  ];

  if (!isLoading) {
    const userData = userInfo?.data;
    if (isSuccess && userData) {
      if (!userData.plan && !userData.domains?.length) {
        return <Navigate to="/membership-steps" />;
      }

      return (
        <>
          {domain === 'no-domain' &&
          !noDomainIsOkRoutes.some(path => pathname.includes(path)) ? (
            <IconAlert variant="warning">
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                هیچ دامنه‌ای اضافه نکرده‌اید. برای استفاده از ابزار ها باید
                دامنه اضافه شود.{' '}
                <Link to="/domains/">
                  <IconButton
                    icon="globe"
                    variant="falcon-primary"
                    iconClassName="me-2"
                  >
                    ورود به دامنه‌ها
                  </IconButton>
                </Link>
              </div>
            </IconAlert>
          ) : (
            <Outlet />
          )}
        </>
      );
    }

    removeCookie(import.meta.env.VITE_ACCESS_TOKEN_NAME, true);
    removeCookie(import.meta.env.VITE_REFRESH_TOKEN_NAME, true);
    return <Navigate to="login" />;
  }

  return <AuthPreload />;
};

export default ProtectedRoute;
